import { API_SERVICE } from "@/services/api.service";

export default {
    namespaced: true,
    state :{
        affiliateLinks: []
    },
    mutations:{
        SET_AFFILIATE_LINKS(state, data){
            state.affiliateLinks = data
            console.log(state.affiliateLinks);
        },
    },
    getters:{
        affiliateLinks(state){
            return state.affiliateLinks;
        },
    },
    actions:{
        getAffiliateLinks({commit}, payload){
            return API_SERVICE.get("peoplePortalRestAPI", `/affiliate/links/${payload.flow}?clientName=${payload.clientName}`)
                .then((res) => {
                    if(res.status === "200"){
                        commit("SET_AFFILIATE_LINKS", res.data)
                    }
                    return res; // Return the response for promise chaining
                })
                .catch((error) => {
                    console.error("Error fetching affiliate links:", error);
                    // You could also commit an error state here if needed
                    // commit("SET_ERROR", error.message);
                    return Promise.resolve(); // Prevent unhandled rejections
                });
        }
    }
}